import { render, staticRenderFns } from "./Feedbacks.vue?vue&type=template&id=5132be70&scoped=true&"
import script from "./Feedbacks.vue?vue&type=script&lang=js&"
export * from "./Feedbacks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5132be70",
  null
  
)

export default component.exports